/* eslint-disable no-nested-ternary */
// eslint-disable-next-line import/no-extraneous-dependencies
import { GrowthBook } from '@growthbook/growthbook';
import storeMutations from '~/store/constants/storeMutations';

interface Store {
  commit: (mutation: string, payload: any) => void;
}

// from Growthbook auto-attributes plugin https://github.com/growthbook/growthbook/blob/main/packages/sdk-js/src/plugins/auto-attributes.ts
function getBrowserDevice(ua: string | null | undefined): { browser: string; deviceType: string; uiDeviceType: string } {
  const safeUA = ua || ''; // Prevent errors if `ua` is null/undefined

  // Detect browser
  const browser = safeUA.match(/Edg/) ? 'edge'
    : safeUA.match(/Chrome/) ? 'chrome'
      : safeUA.match(/Firefox/) ? 'firefox'
        : safeUA.match(/Safari/) ? 'safari' : 'unknown';

  // Detect device type based on UA
  const deviceType = safeUA.match(/Mobi/) ? 'mobile' : 'desktop';

  // Handle SSR safely
  const width = typeof window !== 'undefined' ? window.innerWidth : 1200; // Default to desktop
  const uiDeviceType = width < 768 ? 'mobile' : width < 1200 ? 'tablet' : 'desktop';

  return { browser, deviceType, uiDeviceType };
}

export async function createGrowthbookInstance(store: Store, sessionId: string) {
  if (!sessionId) {
    // If no ID is available, we can still create the instance but the user will be excluded from tests
    console.warn('No ID available. User will be excluded from Growthbook tests.');
  }

  const growthbookInstance = new GrowthBook({
    apiHost: process.env.NUXT_ENV_GROWTHBOOK_URL,
    clientKey: process.env.NUXT_ENV_GROWTHBOOK_KEY,
    attributes: {
      ...getBrowserDevice(navigator.userAgent),
      id: sessionId,
    },
    trackingCallback: (experiment, result) => {
      const exp = { id: experiment.key, variant: result.key };
      store.commit(storeMutations.REGISTER_GROWTHBOOK_EXPERIMENTS, exp);

      window.dataLayer.push({
        event: 'experiment_viewed',
        experiment: {
          name: experiment.key,
          anonId: sessionId,
          result,
        },
      });
    },
    enableDevMode: process.env.NUXT_ENV_IS_DEV === 'true',
  });

  await storeGrowthbookFeatures(growthbookInstance, store);
  store.commit(storeMutations.SET_GROWTHBOOK_INITIALIZED, true);

  return growthbookInstance;
}

async function storeGrowthbookFeatures(growthbookInstance: GrowthBook, store: Store) {
  await growthbookInstance.loadFeatures();
  Object.keys(growthbookInstance.getFeatures()).forEach((key) => {
    store.commit(storeMutations.SET_FEATURE_FLAG, { key, isOn: growthbookInstance.isOn(key) });
  });
}
